import React from 'react';
import { FadeUp, SlideLeft, SlideRight } from '../../../components/shared/Motion';
import { EditableText } from '../../components';
import { getIcon } from '../iconMap';

function Pane({ icon, title, body, bgClass, onTitleChange, onBodyChange }) {
  const I = getIcon(icon);
  return (
    <div className={`relative h-full rounded-2xl p-10 flex flex-col gap-5 text-white ${bgClass} hover:scale-[1.02] transition-transform duration-500 overflow-hidden group`}>
      <div className="absolute inset-0 bg-grid-olive [background-size:28px_28px] opacity-25" />
      <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-accent/15 blur-3xl group-hover:bg-accent/30 transition-colors duration-700" />
      <div className="relative inline-flex h-14 w-14 items-center justify-center rounded-full bg-accent text-ink shadow-[0_14px_30px_-10px_rgba(197,120,99,0.7)]">
        <I size={26} />
      </div>
      <EditableText value={title} onChange={onTitleChange} as="h3" className="relative font-display text-3xl lg:text-4xl font-bold leading-tight" />
      <EditableText value={body} onChange={onBodyChange} as="p" multiline className="relative text-white/85 leading-relaxed text-lg" />
      <div className="relative mt-auto pt-2 h-[3px] w-full bg-accent rounded-full shadow-[0_0_18px_rgba(197,120,99,0.6)]" />
    </div>
  );
}

function VisionMission({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const updateField = (key, patch) => update({ [key]: { ...(data[key] || {}), ...patch } });
  return (
    <section className="relative py-24 lg:py-32 bg-white overflow-hidden">
      <div className="container-page">
        <FadeUp className="text-center max-w-3xl mx-auto mb-14">
          <span className="eyebrow justify-center"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading_prefix} onChange={(t) => update({ heading_prefix: t })} as="span" />
            <span className="text-gradient"><EditableText value={data.heading_highlight} onChange={(t) => update({ heading_highlight: t })} as="span" /></span>
            <EditableText value={data.heading_suffix} onChange={(t) => update({ heading_suffix: t })} as="span" />
          </h2>
        </FadeUp>

        <div className="grid lg:grid-cols-2 gap-7">
          <SlideLeft className="h-full">
            <Pane
              icon={data.vision?.icon}
              title={data.vision?.title}
              body={data.vision?.body}
              bgClass="bg-olive-deep"
              onTitleChange={(t) => updateField('vision', { title: t })}
              onBodyChange={(t) => updateField('vision', { body: t })}
            />
          </SlideLeft>
          <SlideRight className="h-full">
            <Pane
              icon={data.mission?.icon}
              title={data.mission?.title}
              body={data.mission?.body}
              bgClass="bg-olive"
              onTitleChange={(t) => updateField('mission', { title: t })}
              onBodyChange={(t) => updateField('mission', { body: t })}
            />
          </SlideRight>
        </div>
      </div>
    </section>
  );
}

export default VisionMission;
